"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeWireBundle = decodeWireBundle;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const entity_list_1 = require("./entity-list");
const decode_prop_block_1 = require("./decode-prop-block");
const decode_tc11_wire_segment_1 = require("./decode-tc11-wire-segment");
const typeCodes_1 = require("../typeCodes");
function decodeWireBundle(node, path, warnings) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:8 (WireBundle), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const c = node.children;
    if (c.length !== 7) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `tc:8 (WireBundle) has ${c.length} children, expected 7`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const detected = c[2].type === 'container' || c[2].type === 'econtainer' ? (0, entity_list_1.detectEntityList)(c[2].children) : null;
    const segments = (0, entity_list_1.decodeEntityList)(c[2], null, `${path}/segments`, warnings, (item, _i, itemPath) => (0, decode_tc11_wire_segment_1.decodeWireSegment)(item, itemPath, warnings)) ?? c[2];
    const props = (0, decode_prop_block_1.decodePropBlock)(c[6], `${path}/props`, warnings);
    const isBus = detected !== null && detected.typeCode === typeCodes_1.TypeCode.BusSegment;
    const rowAtom = c[5];
    const styleRowIndex = rowAtom.type === 'atom' && /^\d+$/.test(rowAtom.content.trim()) ? rowAtom.content.trim() : null;
    return {
        kind: 'wire-bundle',
        segments,
        props,
        isBus,
        styleRowIndex,
        raw: node,
    };
}
function stripPrefix(s, prefix) {
    if (!s.startsWith(prefix)) {
        return null;
    }
    return s.slice(prefix.length);
}
//# sourceMappingURL=decode-tc8-wire-bundle.js.map